import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M40 64v128a16 16 0 0016 16h160a8 8 0 008-8V88a8 8 0 00-8-8H56a16 16 0 01-16-16h0a16 16 0 0116-16h136"
      />
      <circle cx="180" cy="144" r="12" />
    </svg>
  );
}

export default Icon;
